import { render, staticRenderFns } from "./ChangeUsersRoleDialog.vue?vue&type=template&id=7269f8ee&scoped=true&"
import script from "./ChangeUsersRoleDialog.vue?vue&type=script&lang=ts&"
export * from "./ChangeUsersRoleDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7269f8ee",
  null
  
)

export default component.exports